import { render } from "./VerificationAlert.vue?vue&type=template&id=151e485f"
import script from "./VerificationAlert.vue?vue&type=script&lang=js"
export * from "./VerificationAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__